import { getRequest, postRequest, putRequest, replaceInUrl } from './index';
import apiEndpoints from './apiEndpoints';

export const getFundingSourceRequest = () =>
  getRequest(apiEndpoints.funding_source.getFundingSource);

export const getAccountPurposeRequest = () =>
  getRequest(apiEndpoints.funding_source.getAccountPurposeSource);

export const createApplicationFundingSourceRequest = ({
  applicationUid,
  data,
}) =>
  postRequest(
    replaceInUrl(apiEndpoints.funding_source.applicationFundingSource, {
      applicationUid,
    }),
    data,
  );

export const updateApplicationFundingSourceRequest = ({
  applicationUid,
  data,
}) =>
  putRequest(
    replaceInUrl(apiEndpoints.funding_source.applicationFundingSource, {
      applicationUid,
    }),
    data,
  );
export const getAccountFundingDetails = ({ applicationUid }) =>
  getRequest(
    replaceInUrl(apiEndpoints.funding_source.applicationFundingSource, {
      applicationUid,
    }),
  );
